import { requestHelpers } from '../../helpers';

export const actions = {
    GET_RATINGS_SUCCESS: "GET_RATINGS_SUCCESS",
    POST_RATINGS_SUCCESS: "POST_RATINGS_SUCCESS",
}

export const ratingApiCall = ( personId, networkId, rating, method ) => {
    const endpoint = `/people/${personId}/rating/${networkId}`;
    return ( dispatch ) => {
        requestHelpers
            .authenticatedPostRequest( endpoint, rating && {rating}, method )
            .then( ( response ) => {
                return dispatch( {
                    type: method === 'GET' && actions.GET_RATINGS_SUCCESS,
                    body: method === 'GET' && response.data.ratingCount,
                })
            } )
            .catch( ( error ) => {
                console.log( `ERROR ${ error }` )
            } )
    }
}

export const sendPostRatingAction = () => {
    return ( dispatch ) => {
        dispatch( {
            type: actions.POST_RATINGS_SUCCESS,
            body: 1,
        } )
    }
}


// WEBPACK FOOTER //
// src/client/actions/ratings/ratings.js